import React, { createContext, useContext } from 'react';
import type { MerchantPreset } from './types';
import { NEUTRAL_MERCHANT_PRESET } from './neutral';

const MerchantPresetContext = createContext<MerchantPreset>(NEUTRAL_MERCHANT_PRESET);

export function MerchantPresetProvider({
  value,
  children,
}: {
  value: MerchantPreset;
  children: React.ReactNode;
}) {
  return <MerchantPresetContext.Provider value={value}>{children}</MerchantPresetContext.Provider>;
}

/** Active merchant preset; neutral when rendered outside a ChatWidget. */
export function useMerchantPresetContext(): MerchantPreset {
  return useContext(MerchantPresetContext);
}
